(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/overview-hero/assets/javascripts/common/play-button.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/overview-hero/assets/javascripts/common/play-button.js');

'use strict';

const {
  useDispatch
} = ReactRedux;
const Button = svs.ui.ReactButton;
const {
  getDisplayName
} = svs.utils.products;
const {
  getGameUrl,
  preventDoubleClick
} = svs.components.lbUtils;
const {
  showDialogAction
} = svs.components.marketplaceCompetition.services.actions.dialogActions;
const {
  resolveCompetitionUrl
} = svs.components.marketplaceCompetition.helpers;
const logger = svs.core.log.getLogger('marketplace-competition:overview-hero');
const PlayButton = _ref => {
  let {
    competition,
    label
  } = _ref;
  const dispatch = useDispatch();
  const compUrl = resolveCompetitionUrl(competition.compType);
  const {
    currentDrawNumber,
    productId
  } = (competition === null || competition === void 0 ? void 0 : competition.details) || {};
  const productName = getDisplayName(productId);
  const navigateToProductPage = _ref2 => {
    let {
      subPath,
      search
    } = _ref2;
    if (productId && currentDrawNumber) {
      const path = getGameUrl({
        productId,
        drawNumber: currentDrawNumber,
        options: {
          subPath,
          search
        }
      });
      if (path) {
        window.location.href = window.location.origin + path;
        return;
      }
    }
    logger.info("Could not create game url, competitionId: ".concat(competition === null || competition === void 0 ? void 0 : competition.id, " productId: ").concat(productId, " currentDrawNumber: ").concat(currentDrawNumber));
    dispatch(showDialogAction({
      title: 'Något gick fel',
      text: 'Vi kunde inte öppna sidan. Försök igen senare.',
      icon: 'exclamation-sign',
      type: 'error',
      buttons: [{
        text: 'Okej'
      }]
    }));
  };
  const handleSettleBet = () => navigateToProductPage({
    subPath: "/".concat(compUrl)
  });
  return React.createElement("div", {
    className: "overview-hero-button-container"
  }, React.createElement(Button, {
    "aria-label": "Spela ".concat(productName),
    className: "qa-competition-overview-hero-put-bet-button competition-overview-hero-put-bet-button",
    href: "".concat(getGameUrl({
      productId,
      drawNumber: currentDrawNumber,
      options: {
        subPath: "/".concat(compUrl)
      }
    })),
    onClick: e => {
      e.stopPropagation();
      e.nativeEvent.stopImmediatePropagation();
      preventDoubleClick(handleSettleBet);
    }
  }, label || "Spela ".concat(productName)));
};
setGlobal('svs.components.marketplaceCompetition.overviewHero.common.PlayButton', PlayButton);

 })(window);